import { Voice } from './audio-engine';
import * as THUD from './kits/thud';
import * as CRISP from './kits/crisp';
import * as SNAP from './kits/snap';
import * as TONAL from './kits/tonal';
/* ============================================================
   音效配方的註冊表
   ============================================================

   引擎在 `audio-engine.ts`（匯流排、發聲上限、距離、三個原語），
   配方在 `kits/` 底下 —— 跟武器特效的 `render/vfx-style.ts` 是同一個形狀：
   **`SFX.*` 仍是唯一入口，內部問一句「現在是哪個配方」再分派。**

   ## 現況

   | id | 名稱 | 狀態 |
   |---|---|---|
   | `snap` | 硬質點擊 | **使用者 2026-08-06 選定**。三個高頻音自己做，其餘十一個 re-export `thud` |
   | `crisp` | 乾淨脆響 | 同一輪的另一個候選，落選，留著當對照 |
   | `thud` | 悶厚工業 | 2026-08-05 選定，2026-08-06 使用者：「太悶」。十四個音完整 |
   | `tonal` | 有調性電子 | 2026-08-06 使用者：「太怪不搭」。十四個音完整 |

   ⚠️ **`snap` 的其餘十一個音仍是 `thud` 的悶厚版本**（爆炸、警報、升級、
   傳送門⋯⋯）。這一輪只換了每秒響幾十次的那三個 —— 它們才是「難受」的來源。
   要不要把剩下十一個也搬成硬質點擊，是下一輪的決定。

   ⚠️ 使用者先選了 `tonal`、補完十四個音之後改口要 `thud`。
   兩套都是完整的，所以測試台切過去是**同一組事件的兩種完整詮釋**，
   不是「完整 vs 半成品」—— 之後若要再翻案，兩邊的成本一樣。

   `play()` 找不到配方就回 `false`，`platform/audio.ts` 會退回第一版的嗶聲。

   ## 被否決的（不要走回頭路）

   **撞擊優先・極簡**（白噪瞬態 + 下滑低頻）→ 使用者：「不好聽，而且很躁」。

   病因：白噪集中在 2–5 kHz，那是耳朵最敏感也最容易疲勞的頻段，
   而命中每秒響十幾次。**只要高頻事件的瞬態還是噪音，怎麼調都會刺** ——
   上面兩個候選都是從「把噪音拿掉」出發的，一個往低頻走、一個往純音走。 */

export type KitId = 'thud' | 'tonal' | 'crisp' | 'snap';

var KITS: Record<string, any> = { thud: THUD, tonal: TONAL, crisp: CRISP, snap: SNAP };
export var KIT_IDS: KitId[] = ['thud', 'tonal', 'crisp', 'snap'];
export var KIT_ZH: Record<string, string> = { thud: '悶厚工業', tonal: '有調性電子', crisp: '乾淨脆響', snap: '硬質點擊' };
var active: KitId = 'snap';   // 使用者 2026-08-06 選定

export function setKit(id: KitId) { if (KITS[id]) active = id; return active; }
export function activeKit() { return active; }

/** 依名字播一個音。回 `false` = 這個配方沒有做這個音，呼叫端該退回第一版。 */
export function play(name: string, o?: Voice) {
  var fn = KITS[active][name];
  if (typeof fn !== 'function') return false;
  fn(o || {});
  return true;
}

export function sfxShoot(o?: Voice) { play('shoot', o); }
export function sfxHit(o?: Voice) { play('hit', o); }
export function sfxKill(o?: Voice) { play('kill', o); }
